import React from "react";
import * as RadixScrollArea from "@radix-ui/react-scroll-area";

interface ScrollAreaProps {
  children: React.ReactNode;
  className?: string;
  type?: "auto" | "always" | "scroll" | "hover";
}

/**
 * ScrollArea component using Radix UI ScrollArea primitive.
 *
 * Benefits over native overflow scrolling:
 * - Prevents accidental button clicks during scroll interactions
 * - Custom cross-browser scrollbar styling
 * - Overlays on content without taking layout space
 * - Native scrolling performance
 */
export default function ScrollArea({
  children,
  className = "",
  type = "auto",
}: ScrollAreaProps) {
  return (
    <RadixScrollArea.Root className={`overflow-hidden ${className}`} type={type}>
      <RadixScrollArea.Viewport className="w-full h-full overflow-x-hidden">
        {children}
      </RadixScrollArea.Viewport>
      <RadixScrollArea.Scrollbar
        className="hidden lg:flex touch-none select-none p-0.5 bg-gray-900/50 transition-colors duration-150 hover:bg-gray-900 data-[orientation=vertical]:w-2.5 data-[orientation=horizontal]:h-2.5 data-[orientation=horizontal]:flex-col"
        orientation="vertical"
      >
        <RadixScrollArea.Thumb className="flex-1 bg-purple-700 rounded-full relative before:content-[''] before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:w-full before:h-full before:min-w-[44px] before:min-h-[44px]" />
      </RadixScrollArea.Scrollbar>
      <RadixScrollArea.Corner className="hidden lg:block bg-gray-900" />
    </RadixScrollArea.Root>
  );
}
